import { jsx as _jsx } from "react/jsx-runtime";
export const ChipsRow = ({ className, children, }) => {
    const classNames = `u-flex u-flex--align-items-center u-g-xs u-overflow-x-auto ${className || ''}`;
    return (_jsx("div", { className: classNames, "data-testid": "chips-row", children: children }));
};
//# sourceMappingURL=ChipsRow.js.map